<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
        <div class="detailsTitle">
            <div class="detailsWrap"></div>
            <p>公告</p>
        </div>

        <el-form>
            <el-form-item label='公告名稱:'>
                <input maxlength="20" class="el-input__inner" type="text" v-model="billBoardName">
            </el-form-item>
            <!-- <el-form-item label='公告內容'>
                <el-input
                    ref="notice"
                    v-model="billBoard"
                    type="textarea"
                    maxlength='100'
                    show-word-limit
                    :autosize="{ minRows: 2}"
                    placeholder="請輸入公告">

                </el-input>


            </el-form-item> -->

            <div class="editor-wrap">
                <p class="editor-title normal_font">公告内容:</p>
                <Editor class="editor" style="color:#fff;" @listenContent='getContent' :colorFlag = true :content='billBoard' :newsFlag='false' :billFlag='true'></Editor>
            </div>
        </el-form>
        <div class="bottomBtn">
            <!-- <div class="btn" @click="reset()">重置</div> -->
            <div class="btn" @click="completeBillBoard()">保存</div>
        </div>
    </div>


    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import Editor from '@/components/editor';
import DiaMess from '@/components/dialog';

export default {
  data () {
    return {
      navBlock: '社區  /  話題列表',
      navtitle:'編輯公告',
      billBoardName: '', //公告名称
      billBoard: '', //公告内容
      dialogVisible: false,
    }
  },
  created(){
    this.getBillBoard();
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 实时更新富文本内容
    getContent(data){
      this.billBoard = data;
    },
    // 获取公告
    getBillBoard(){
      let _this = this;
      _this.$get('/request/community/getBillboard', _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            _this.billBoardName = res.data.titile;
            _this.billBoard = res.data.message;
          } else {
            _this.$propMessage(res.message, 'error');

          }
        });
    },
    //完成编辑公告
    completeBillBoard(){
      let _this = this;
      if(_this.billBoard !== '' && _this.billBoard.replace(/\s+/g,"")=="") {
        _this.dialogVisible = true;

        _this.$propMessage('请输入公告内容', 'error',
        function(){
          _this.dialogVisible = false;
        });
        return false
      }

      console.log(_this.billBoard)

      console.log(_this.billBoard.replace(/\n/g,"<br />"))



      _this.$confirm('是否提交公告內容?', '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
        closeOnClickModal: false
        }).then(() => {
          _this.$get(`/request/community/setBillboard?msg=${_this.billBoard}&title=${_this.billBoardName}`, _this.$GLOBAL.jsonConfig)
            .then((res) => {
              if (res.code === '00000') {
                _this.dialogVisible = true;
                _this.$propMessage('编辑公告發佈成功','success',
                  function(){
                    _this.dialogVisible = false;
                  })
              } else {
                _this.dialogVisible = true;
                _this.$propMessage(res.message, 'error',
                function(){
                  _this.dialogVisible = false;
                });

              }
            });
        }).catch((err) => {
            console.log(err)
        });


    },
  },
  components: {
    NavBar,
    Editor,
    DiaMess
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/community/editBillBoard.vue